export const idealRoundFixed = (num: number, decimals: number): string =>
	new Intl.NumberFormat(
		'en-US', 
		{ minimumFractionDigits: decimals, maximumFractionDigits: decimals }
	).format(num);

export const idealRound = (num: number, decimals: number): number =>
	Number(idealRoundFixed(num, decimals));

/**
 * Check if a value is excluded from a specified range.
 * e.g., isRangeExcludingValue(18, 24)(25) will get true.
 * 
 * @param startRange - The start of the range.
 * @param endRange - The end of the range.
 * @returns A function that accepts a value to check that excluded from the range.
 */
export const isRangeExcludingValue = (startRange: number, endRange: number) => {
	/**
	 * @param excludedValue - The value to be excluded from the range.
	 * @returns Whether the value is excluded from the range.
	 */
	return (excludedValue: number) => {
		return (startRange < excludedValue && endRange < excludedValue) || 
			(startRange > excludedValue && endRange > excludedValue);
	};
};

export const calculatePercentage = (
	current: number, 
	total: number, 
	decimalPlaces = 0
) => {
	if (total === 0 || current === 0) return 0;
	if (current === total) return 100;

	const percentage = (current / total) * 100;
	const power = Math.pow(10, decimalPlaces);
	
	return Math.round(percentage * power) / power;
};